import {
  Button,
  HStack,
  Input,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Code,
  Box,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import {
  ValleyFileGraph,
  MatchingFileRecords,
  valleyFiles,
} from '@finley-technologies/valley-bank-utils';

import { CSVPreview } from '../CSVPreview';

type Props = { graph: ValleyFileGraph };
export const ValleyFileQuery = ({ graph }: Props) => {
  const [inputValue, setInputValue] = useState('');
  const [records, setRecords] = useState<MatchingFileRecords[]>([]);
  const searchableFileAndKeys = valleyFiles.getSearchableFileAndKeys();
  const uniqueKeys = new Set(
    searchableFileAndKeys.map((fileAndKey) => fileAndKey.key),
  );
  const placeHolderString = `Enter any of: ${Array.from(uniqueKeys).join(
    ', ',
  )}`;

  useEffect(() => {
    setRecords(valleyFiles.getRandomSampleRecords(graph));
  }, [graph]);

  const handleRandom = (event: React.FormEvent) => {
    setInputValue('');
    event.preventDefault();
    setRecords(valleyFiles.getRandomSampleRecords(graph));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const recordsFound: MatchingFileRecords[] = [];
    searchableFileAndKeys.forEach(({ file, key }) => {
      valleyFiles
        .gatherMatchingData({
          graph,
          file,
          key,
          value: inputValue,
        })
        .forEach((record) => {
          recordsFound.push(record);
        });
    });
    setRecords(valleyFiles.consolidateMatchingRecords(recordsFound));
  };

  return (
    <VStack align="start">
      {/* Ensure VStack aligns items to start (left) */}
      <HStack
        as="form"
        onSubmit={handleSubmit}
        onReset={handleRandom}
        width="100%"
      >
        {/* HStack for horizontal layout of Input and Button */}
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={placeHolderString}
        />
        <Button type="submit">Search</Button>
        <Button type="reset">Random</Button>
      </HStack>
      {records.length > 0 ? (
        <Tabs isFitted variant="enclosed" width="100%">
          <Box overflowX="auto" width="100%" padding="4">
            {/* Tabs should layout horizontally by default */}
            <TabList mb="1em">
              {records.map((record) => (
                <Tab key={record.file}>
                  {record.file}:{record.matchingRecords.length}
                </Tab>
              ))}
            </TabList>
          </Box>
          <TabPanels>
            {records.map((record) => (
              <TabPanel key={record.file}>
                <CSVPreview data={record.matchingRecords} /> {/* Tab content */}
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      ) : (
        <Code>{JSON.stringify(graph.stats, null, 4)}</Code>
      )}
    </VStack>
  );
};
